// // import { Card, Row, Col, Statistic, Badge } from "antd";
// // import HighchartsReact from "highcharts-react-official";
// // import Highcharts from "highcharts";
// // import classes from "./operational.module.scss";
// // import { Typography } from "antd";
// // const { Title, Text } = Typography;

// // const Compliance = () => {
// //   // Dummy KPIs
// //   const complianceKpis = [
// //     { title: "Compliance Health", value: "Excellent", status: "success" },
// //     { title: "Regulatory Risk Level", value: "Low", status: "processing" },
// //     { title: "Policy Update Status", value: "82%", suffix: "" },
// //   ];

// //   // Dummy Compliance Trend Chart
// //   const complianceTrendChart = {
// //     chart: { type: "line" },
// //     title: { text: "Compliance Status Over Time" },
// //     xAxis: { categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"] },
// //     yAxis: { title: { text: "Compliance Score (%)" } },
// //     series: [
// //       {
// //         name: "Compliance Score",
// //         data: [60, 70, 75, 80, 85, 90],
// //       },
// //     ],
// //   };

// //   return (
// //     <>
// //       {" "}
// //       <div className={classes.header}>
// //         <Title level={4} style={{ marginTop: 0 }}>
// //           Compliance System
// //         </Title>
// //         <Text type="secondary" style={{ fontSize: 12 }}>
// //           Show risk/legal/compliance status of the company and its vendors.
// //         </Text>
// //       </div>
// //       <div style={{ padding: "20px" }}>
// //         {/* KPI Cards */}
// //         <Row gutter={[16, 16]}>
// //           {complianceKpis.map((kpi, index) => (
// //             <Col span={8} key={index}>
// //               <Card>
// //                 {kpi.status ? (
// //                   <>
// //                     <Statistic
// //                       title={kpi.title}
// //                       valueRender={() => (
// //                         <span>
// //                           <Badge
// //                             status={kpi.status}
// //                             style={{ marginRight: 8 }}
// //                           />
// //                           {kpi.value}
// //                         </span>
// //                       )}
// //                     />
// //                   </>
// //                 ) : (
// //                   <Statistic
// //                     title={kpi.title}
// //                     value={kpi.value}
// //                     suffix={kpi.suffix || ""}
// //                   />
// //                 )}
// //               </Card>
// //             </Col>
// //           ))}
// //         </Row>

// //         {/* Compliance Trend Chart */}
// //         <Row style={{ marginTop: 30 }}>
// //           <Col span={24}>
// //             <Card title="Compliance Trend">
// //               <HighchartsReact
// //                 highcharts={Highcharts}
// //                 options={complianceTrendChart}
// //               />
// //             </Card>
// //           </Col>
// //         </Row>
// //       </div>
// //     </>
// //   );
// // };
// // export default Compliance;


// import {
//   Row,
//   Typography
// } from "antd"
// import {
//   DashboardOutlined,
// } from "@ant-design/icons"
// import IntelligenceCore from "./components/IntelligenceCore"
// import RiskForecast from "./components/RiskForecast"
// import StatusOverview from "./components/StatusOverview"
// import ExecutionTracker from "./components/ExecutionTracker"
// import RegulationScanner from "./components/RegulationScanner"
// import RoiCostMeter from "./components/RoiCostMeter"
// import EnforcementZone from "./components/EnforcementZone"
// import AuditSnapshot from "./components/AuditSnapshot"

// const { Title, Text } = Typography

// export default function ComplianceDashboard() {
//   return (
//     <div style={{ padding: "24px", backgroundColor: "#f0f2f5", minHeight: "100vh" }}>
//       <div style={{ marginBottom: "24px" }}>
//         <Title level={1} style={{ margin: 0 }}>
//           <DashboardOutlined style={{ color: "#1890ff" }} /> RADAR+ COMPLIANCE DASHBOARD
//         </Title>
//         <Text type="secondary">Real-time compliance intelligence and risk management</Text>
//       </div>

//       <IntelligenceCore />
//       <RiskForecast />
//       <StatusOverview />
//       <ExecutionTracker />
//       <Row gutter={[16, 16]}>
//         <RegulationScanner />
//         <RoiCostMeter />
//       </Row>
//       <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
//         <EnforcementZone />
//         <AuditSnapshot />
//       </Row>
//     </div>
//   )
// }


import { Card, Typography, Button, Table, Badge, Space, Row, Col } from "antd"
import {
  ExclamationCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  EyeOutlined,
  GlobalOutlined,
  WarningOutlined,
  FileTextOutlined,
  SyncOutlined,
} from "@ant-design/icons"
import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official"

const { Title, Text } = Typography

export default function ComplianceDashboard() {
  // Circular chart configuration
  const chartOptions = {
    chart: {
      type: "pie",
      height: 200,
      backgroundColor: "transparent",
    },
    title: {
      text: '73.2%<br><span style="font-size: 14px; color: #666;">Overall</span>',
      align: "center",
      verticalAlign: "middle",
      useHTML: true,
      style: {
        fontSize: "24px",
        fontWeight: "bold",
        color: "#333",
      },
    },
    plotOptions: {
      pie: {
        innerSize: "70%",
        startAngle: -90,
        endAngle: 90,
        dataLabels: {
          enabled: false,
        },
        enableMouseTracking: false,
      },
    },
    series: [
      {
        data: [
          { y: 73.2, color: "#52c41a" },
          { y: 26.8, color: "#f0f0f0" },
        ],
      },
    ],
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
  }

  // Violation forecast data
  const violationData = [
    {
      key: "1",
      violation: "Employee data deletion",
      timeline: "20 days",
      riskCost: "$25K",
      riskLevel: "Medium",
      riskColor: "orange",
    },
    {
      key: "2",
      violation: "Lax controls for third party processing",
      timeline: "40 days",
      riskCost: "$80K",
      riskLevel: "High",
      riskColor: "red",
    },
    {
      key: "3",
      violation: "GDPR consent process outdated",
      timeline: "50 days",
      riskCost: "$120K",
      riskLevel: "Low",
      riskColor: "green",
    },
  ]

  const violationColumns = [
    {
      title: "Predilmental violations",
      dataIndex: "violation",
      key: "violation",
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Timeline",
      dataIndex: "timeline",
      key: "timeline",
    },
    {
      title: "Risk Cost",
      dataIndex: "riskCost",
      key: "riskCost",
    },
    {
      title: "Risk Level",
      dataIndex: "riskLevel",
      key: "riskLevel",
      render: (text, record) => <Text>{text}</Text>,
    },
  ]

  return (
    <div className="min-h-screen bg-white p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <Title level={1} className="text-gray-900 mb-2">
            Compliance Dashboard
          </Title>
          <Text className="text-gray-600 text-lg">
            Monitor operational risk categories, with key compliance exposure highlighted.
          </Text>
        </div>

        {/* Main Content Grid */}
        <Row gutter={[24, 24]}>
          {/* Compliance Intelligence Core */}
          <Col xs={24} lg={12}>
            <Card className="h-full">
              <div className="flex items-center mb-4">
                <ExclamationCircleOutlined className="text-blue-500 mr-2" />
                <Title level={4} className="mb-0">
                  Compliance Intelligence Core
                </Title>
              </div>

              <Row gutter={[16, 16]}>
                <Col span={12}>
                  <HighchartsReact highcharts={Highcharts} options={chartOptions} />
                </Col>
                <Col span={12}>
                  <div className="space-y-3">
                    <Text strong className="block text-gray-600">
                      TOP Com PRLTisks
                    </Text>
                    <div className="space-y-2">
                      <div className="flex items-center">
                        <WarningOutlined className="text-red-500 mr-2" />
                        <div>
                          <Text strong>HIPAA risk highest: 33.2%</Text>
                        </div>
                      </div>
                      <div className="flex items-center">
                        <CheckCircleOutlined className="text-green-500 mr-2" />
                        <Text>GDPR consent missing</Text>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <div className="mt-6 pt-4 border-t">
                <Text className="text-gray-600 font-bold block mb-3">Exposure Overview</Text>
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <div className="flex items-center">
                      <ExclamationCircleOutlined className="text-gray-400 mr-2" />
                      <Text>HIPAA risk highest</Text>
                    </div>
                    <Text strong>33.2%</Text>
                  </div>
                  <div className="flex justify-between items-center">
                    <div className="flex items-center">
                      <ExclamationCircleOutlined className="text-gray-400 mr-2" />
                      <Text>GDPR consent missing</Text>
                    </div>
                    <Text strong>33%</Text>
                  </div>
                </div>
                <div className="mt-4 flex justify-between items-center">
                  <Text>
                    Confidence Score:{" "}
                    <Text strong className="text-green-500">
                      85%
                    </Text>
                  </Text>
                  <Text className="text-gray-500">Last Updated: just now</Text>
                </div>
              </div>
            </Card>
          </Col>

          {/* Violation Risk Forecast Engine */}
          <Col xs={24} lg={12}>
            <Card className="h-full">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center">
                  <ClockCircleOutlined className="text-orange-500 mr-2" />
                  <Title level={4} className="mb-0">
                    Violation Risk Forecast Engine
                  </Title>
                </div>
                <Text className="text-gray-500">0 Lota, next: 30-30-30 Days</Text>
              </div>

              <Table
                dataSource={violationData}
                columns={violationColumns}
                pagination={false}
                size="small"
                className="mb-4"
              />

              <div className="flex justify-between items-center mb-4">
                <Text>
                  Learn unco Score:{" "}
                  <Text strong className="text-green-500">
                    85%
                  </Text>
                </Text>
              </div>

              <Space>
                <Button>Update Policy</Button>
                <Button type="primary">Initiate Pre Mitigation</Button>
              </Space>
            </Card>
          </Col>

          {/* Regulation Change Scanner */}
          <Col xs={24}>
            <Card>
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center">
                  <SyncOutlined className="text-blue-500 mr-2" />
                  <Title level={4} className="mb-0">
                    Regulation Change Scanner
                  </Title>
                </div>
                <Space>
                  <Button icon={<EyeOutlined />}>Dept. View</Button>
                  <Button icon={<GlobalOutlined />}>Region View</Button>
                </Space>
              </div>

              <div className="space-y-3">
                <div className="flex items-center justify-between py-2">
                  <div className="flex items-center">
                    <ExclamationCircleOutlined className="text-blue-500 mr-3" />
                    <Text>New req</Text>
                    <Text className="ml-2 text-gray-500">auten Flagged</Text>
                  </div>
                  <Text className="text-gray-500">Update ago</Text>
                </div>
                <div className="flex items-center justify-between py-2">
                  <div className="flex items-center">
                    <ExclamationCircleOutlined className="text-blue-500 mr-3" />
                    <Text>Compliance</Text>
                    <Text className="ml-2 text-gray-500">2 days ago</Text>
                  </div>
                  <Text className="text-gray-500">Update ago</Text>
                </div>
                <div className="flex items-center justify-between py-2">
                  <div className="flex items-center">
                    <FileTextOutlined className="text-blue-500 mr-3" />
                    <Text>Update Policy</Text>
                  </div>
                  <Text className="text-gray-500">Update policy</Text>
                </div>
              </div>
            </Card>
          </Col>

          {/* Bottom Metrics */}
          <Col xs={24}>
            <Row gutter={[16, 16]}>
              <Col xs={12} sm={6}>
                <Card className="text-center">
                  <CheckCircleOutlined className="text-4xl text-green-500 mb-2" />
                  <Title level={2} className="text-green-500 mb-1">
                    67%
                  </Title>
                  <Text>Policy Coverage</Text>
                  <div className="mt-2">
                    <Text className="bg-gray-300 border border-gray-300 px-3 py-1 rounded">Medlamp!</Text>
                  </div>
                </Card>
              </Col>
              <Col xs={12} sm={6}>
                <Card className="text-center">
                  <WarningOutlined className="text-4xl text-orange-500 mb-2" />
                  <Title level={2} className="text-orange-500 mb-1">
                    81%
                  </Title>
                  <Text>below Target</Text>
                  <div className="mt-2">
                    <Text className="bg-gray-300 border border-gray-300 px-3 py-1 rounded">below Target</Text>
                  </div>
                </Card>
              </Col>
              <Col xs={12} sm={6}>
                <Card className="text-center">
                  <CheckCircleOutlined className="text-4xl text-green-500 mb-2" />
                  <Title level={2} className="text-green-500 mb-1">
                    92%
                  </Title>
                  <Text>Compliant</Text>
                  <div className="mt-2">
                    <Text className="bg-gray-300 border border-gray-300 px-3 py-1 rounded">Compliant</Text>
                  </div>
                </Card>
              </Col>
              <Col xs={12} sm={6}>
                <Card className="text-center">
                  <ExclamationCircleOutlined className="text-4xl text-red-500 mb-2" />
                  <Title level={2} className="text-red-500 mb-1">
                    71%
                  </Title>
                  <Text>Data Retention</Text>
                  <div className="mt-2">
                    <Text className="bg-gray-300 border border-gray-300 px-3 py-1 rounded">
                      At-risk
                    </Text>
                  </div>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  )
}
